import { setShowSelectCaveatsModal } from '../State/showSelectCaveatsModal';

export default () => async (dispatch) => {

  dispatch(setShowSelectCaveatsModal(false));
  
}